import { render } from "./materialCompositionSummary.vue?vue&type=template&id=6a10bb63&scoped=true&ts=true"
import script from "./materialCompositionSummary.vue?vue&type=script&lang=ts"
export * from "./materialCompositionSummary.vue?vue&type=script&lang=ts"

import "./materialCompositionSummary.vue?vue&type=style&index=0&id=6a10bb63&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a10bb63"]])

export default __exports__